<template>
  <div class="account-login">
    <div class="account-login-content">
      <div class="input-box">
        <span class="input-label"> {{ letter.accountLabel }}</span>
        <input
          name="account"
          v-model="account"
          class="input"
          :placeholder="letter.accountName"
          @focus="initViewport"
        />
      </div>
      <div class="input-box">
        <span class="input-label">{{ letter.passwordLabel }}</span>
        <input
          name="account"
          v-model="password"
          :placeholder="letter.password"
          class="input"
          type="password"
        />
      </div>
      <!-- 谷歌验证码：白名单游戏且风控触发后展示 -->
      <div class="g-recaptcha" v-show="isOpenGv" id="recaptcha"></div>
      <div class="bottom" v-if="showForgetPwd">
        <div class="forget-password" @click="jumpFindPwd">
          {{ letter.forgetPwd }}
        </div>
      </div>
      <div class="account-login-btn j-account-login-btn" @click="accountLogin">
        {{ letter.login }}
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { initViewport } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
import {
  UPDATE_LOADING,
  SWITCH_SERVER,
  UPDATE_PC_SERVER_ID,
  UPDATE_ROLE_LIST,
  GET_SERVER_LIST
} from '@store/officialTopupNew/';
import {
  TOGGLE_REMEMBER,
  GO_ACCOUNT_LOGIN
} from '@store/officialTopupNew/login';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import {
  RECAPTCHA_SITE_KEY,
  OPEN_GV_GAME_IDS,
  RECAPTCHA_RISK_ERROR_CODES,
  RECAPTCHA_COOKIE_KEY
} from '@configs/recaptcha';
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLogin',
  data() {
    return {
      account: '',
      password: '',
      loading: false,
      canAccountLogin: true,
      /** 是否因风控需要展示验证码 */
      isShowRecaptcha: false,
      /** 验证码是否已过期（点击登录时再提示） */
      isRecaptchaExpired: false
    };
  },
  watch: {
    // 需要展示验证码时加载 SDK
    isOpenGv(open) {
      if (open) {
        this.$nextTick(() => {
          this.loadRecaptchaScript();
        });
      }
    }
  },
  mounted() {
    // Cookie 仍有效时直接展示验证码
    if (this.isOpenGv) {
      this.reportRecaptchaPoint('google_recaptcha_trigger', {
        msg: 'init'
      });
      this.$nextTick(() => {
        this.loadRecaptchaScript();
      });
    }
  },
  beforeDestroy() {
    window.googleVerificationWidget = undefined;
    window.googleVerificationToken = '';
  },
  methods: {
    checkInputValid() {
      if (!this.account.length) {
        alert(this.letter.accountName);
        return false;
      }
      if (!this.password.length) {
        alert(this.letter.password);
        return false;
      }
      return true;
    },
    /** 未完成 / 已过期时的提示文案 */
    getRecaptchaTip(isExpired) {
      return isExpired
        ? this.letter.recaptchaExpired
        : this.letter.completeRecaptcha;
    },
    /** Google 验证码相关埋点 */
    reportRecaptchaPoint(eventName, eventValue = {}) {
      pushTrackEvent({
        eventType: 'google_recaptcha',
        eventName,
        eventValue,
        eventReason: locationType.loginPopup
      });
    },
    /** 在容器 DOM 就绪后渲染验证码 */
    renderRecaptcha() {
      const container = document.getElementById('recaptcha');
      if (!container || !window.grecaptcha) return;

      const self = this;
      container.innerHTML = '';
      window.googleVerificationToken = '';
      window.googleVerificationWidget = undefined;

      window.grecaptcha.ready(() => {
        const readyContainer = document.getElementById('recaptcha');
        if (!readyContainer) return;
        window.googleVerificationWidget = window.grecaptcha.render(
          readyContainer,
          {
            sitekey: RECAPTCHA_SITE_KEY,
            callback(token) {
              window.googleVerificationToken = token;
              self.isRecaptchaExpired = false;
              self.reportRecaptchaPoint('google_recaptcha_pass');
            },
            'error-callback'() {
              window.googleVerificationToken = '';
              self.reportRecaptchaPoint('google_recaptcha_fail', {
                reason: 'error'
              });
            },
            'expired-callback'() {
              window.googleVerificationToken = '';
              self.isRecaptchaExpired = true;
              self.reportRecaptchaPoint('google_recaptcha_fail', {
                reason: 'expired'
              });
              if (
                window.grecaptcha &&
                window.googleVerificationWidget !== undefined
              ) {
                window.grecaptcha.reset(window.googleVerificationWidget);
              }
            }
          }
        );
      });
    },
    /** 清空 token 并重置验证码组件 */
    resetRecaptcha() {
      window.googleVerificationToken = '';
      if (
        window.grecaptcha &&
        window.googleVerificationWidget !== undefined
      ) {
        window.grecaptcha.reset(window.googleVerificationWidget);
        return;
      }
      this.renderRecaptcha();
    },
    /** 加载 reCAPTCHA SDK，验证通过后 token 写入 window.googleVerificationToken */
    loadRecaptchaScript() {
      const self = this;

      if (window.grecaptcha) {
        this.renderRecaptcha();
        return;
      }

      const loadLang = this.lang || 'en-US';
      const existingScript = document.querySelector(
        'script[src*="google.com/recaptcha/api.js"]'
      );
      if (existingScript) {
        this.renderRecaptcha();
        return;
      }

      window.onAccountLoginRecaptchaLoad = () => {
        self.renderRecaptcha();
      };
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.google.com/recaptcha/api.js?onload=onAccountLoginRecaptchaLoad&render=explicit&hl=${loadLang}`;
      script.onerror = () => {
        self.reportRecaptchaPoint('google_recaptcha_fail', {
          reason: 'script_load'
        });
      };
      document.head.appendChild(script);
    },
    /** 是否为要求人机验证的风控错误码 */
    isRecaptchaRiskError(res) {
      const msg = String(res?.msg || '');
      return RECAPTCHA_RISK_ERROR_CODES.some(riskCode =>
        msg.includes(riskCode)
      );
    },
    clearRecaptchaCookie() {
      globalConfig.setCookieWithinDays(RECAPTCHA_COOKIE_KEY, '', -1);
    },
    accountLogin() {
      clickButton({
        btnName: 'account_login_confirm',
        locationKey: locationType.loginPopup
      });
      if (!this.checkInputValid()) {
        return;
      }
      // 已展示验证码时，必须完成人机验证后才允许提交登录
      if (this.isOpenGv && !window.googleVerificationToken) {
        alert(this.getRecaptchaTip(this.isRecaptchaExpired));
        return;
      }
      if (!this.canAccountLogin) {
        return;
      }
      this.canAccountLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(GO_ACCOUNT_LOGIN, {
          account: this.account,
          password: this.password,
          google_recaptcha_token: window.googleVerificationToken || ''
        })
        .then(res => {
          this.loading = false;
          this.canAccountLogin = true;
          this.$store.commit(UPDATE_LOADING, false);
          if (res?.result) {
            this.clearRecaptchaCookie();
            this.isShowRecaptcha = false;
            window.googleVerificationToken = '';
            this.$store.commit(SWITCH_SERVER, 0);
            this.$store.commit(UPDATE_PC_SERVER_ID, 0);
            this.$store.commit(UPDATE_ROLE_LIST, []);
            this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
              this.$store.commit(UPDATE_LOADING, false);
            });
          } else if (this.isRecaptchaRiskError(res)) {
            // 风控要求人机验证
            this.isShowRecaptcha = true;
            globalConfig.setCookieWithinDays(
              RECAPTCHA_COOKIE_KEY,
              'true',
              1 / 24
            );
            this.reportRecaptchaPoint('google_recaptcha_trigger', {
              msg: String(res?.msg || '')
            });
            this.$nextTick(() => {
              this.resetRecaptcha();
            });
            if (res?.msg) {
              alert(res.msg);
            }
          } else {
            // 普通登录失败：已展示验证码时重置，需重新验证
            if (this.isOpenGv) {
              this.reportRecaptchaPoint('google_recaptcha_trigger', {
                msg: String(res?.msg || '')
              });
              this.$nextTick(() => {
                this.resetRecaptcha();
              });
            }
            alert(res?.msg);
          }
        });
    },
    jumpFindPwd() {
      clickButton({
        btnName: 'find_password',
        locationKey: locationType.loginPopup
      });
      const link = `https://pay.${mainHost}/platform/passport.html?gameId=${this.gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`;
      sdkOpenLink({ link: getGlobalGetGotoLink({ link: link }) });
    },
    toggleRemember() {
      this.$store.commit(TOGGLE_REMEMBER);
    },
    initViewport
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isRemember: state => state.login.isRemember,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    showForgetPwd() {
      if (+this.gameId === 386) {
        return false;
      }
      return true;
    },
    /** 白名单游戏且（已触发风控或 Cookie 有效）时展示验证码 */
    isOpenGv() {
      if (!OPEN_GV_GAME_IDS.includes(+this.gameId)) {
        return false;
      }
      return (
        this.isShowRecaptcha || !!globalConfig.getCookie(RECAPTCHA_COOKIE_KEY)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.account-login {
  box-sizing: border-box;
  padding: 0 40px;
  font-size: 22px;
  color: #333;
  &-content {
    width: 100%;
  }
  .input-box {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 6px;
    border: solid 1px #e8e8e8;
    margin-bottom: 20px;

    .input-label {
      font-size: 20px;
      color: #999999;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .login-icon {
      font-size: 30px;
      color: #555;
      margin-right: 16px;
    }
    .input {
      flex: 1;
      font-size: 24px;
    }
  }

  .g-recaptcha {
    margin: 0 0 20px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  &-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
    line-height: 80px;
    height: 80px;
    font-size: 24px;
    color: #fff;
    background: $themeColor;
    border-radius: 6px;
    cursor: pointer;
  }
  .bottom {
    display: flex;
    justify-content: center;
  }
  .forget-password {
    cursor: pointer;
  }
}
</style>
